module.exports = __webpack_public_path__ + "img/checklist.8b9310de.svg";